export default __webpack_public_path__ + "static/media/adam-icon.f8ed765c.svg";